import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=27095f5a&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=27095f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27095f5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27095f5a')) {
      api.createRecord('27095f5a', component.options)
    } else {
      api.reload('27095f5a', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=27095f5a&scoped=true&", function () {
      api.rerender('27095f5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29EgEWqTIn6Oz/JS/comp/DocBox.vue"
export default component.exports